"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RadioButton = exports.RadioButtonList = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var mobx_react_1 = require("mobx-react");
var BootstrapHelper_1 = require("../../../BootstrapHelper");
var RadioButtonList = (0, mobx_react_1.observer)(function (props) {
    var cls = (0, BootstrapHelper_1.B)().bl("radio-button-list");
    return ((0, jsx_runtime_1.jsx)("ul", __assign({ id: props.id, className: "".concat(cls.bem, " ").concat(props.className || "", " ").concat(props.disabled ? "radio-button-list--disabled" : "") }, { children: props.options.map(function (e) {
            return ((0, jsx_runtime_1.jsx)(RadioButton, __assign({ id: e.key, className: e.className, fillContainer: e.fillContainer, inputProps: __assign(__assign({}, e.inputProps), { checked: props.value === e.inputProps.value, name: props.groupName }), onChange: (function (ev) {
                    if (!props.disabled) {
                        props.onItemClick(e);
                    }
                }) }, { children: e.label }), e.label));
        }) })));
});
exports.RadioButtonList = RadioButtonList;
var RadioButton = function (props) {
    var cls = (0, BootstrapHelper_1.B)()
        .bl("radio-button")
        .pmod(props.inputProps.checked ? "selected" : "")
        .pmod(props.fillContainer ? "fill-container" : "").bem;
    return ((0, jsx_runtime_1.jsxs)("label", __assign({ htmlFor: props.inputProps.id, className: "".concat(props.className || "", " ").concat(cls) }, { children: [(0, jsx_runtime_1.jsx)("input", __assign({ onChange: function (e) { return props.onChange(e); } }, props.inputProps, { id: props.id, type: "radio", className: "".concat(props.inputProps.className || "") })), props.children] })));
};
exports.RadioButton = RadioButton;
